import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'

const api = {
  getStoreByCode: `${utils.hostname(
    'activity'
  )}/activity/storeO2O/queryStoreDetail.do`,
  storeList: `${utils.hostname('activity')}/activity/storeO2O/queryStoreList.do`
}

export default {
  // 门店code获取门店信息
  async getStoreByCode({ commit, state }, { storeCode }) {
    try {
      const query_param = {
        store_code: storeCode
      }
      const query = queryString.stringify(query_param)
      const work_res = await fetch(`${api.getStoreByCode}?${query}`)
      const workJson = await work_res.json()
      return workJson
    } catch (e) {
      throw new Error(e)
    }
  },
  async getStoreListByCitycode({ commit, state }, { city_code }) {
    try {
      const query_param = {
        city_code
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.storeList}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      throw new Error(e)
    }
  }
}
